import { RootScopeEvents } from 'common/services/root-scope-types';
const config = [
    {
        rootScopeEvent: RootScopeEvents.MARKETPLACE.CLOSED,
        segmentName: 'Extensions Closed',
        skipSegmentTrackData: true,
    },
    {
        rootScopeEvent: RootScopeEvents.MARKETPLACE.EXTENSION_VOTED,
        segmentName: 'Extension Voted',
        skipSegmentTrackData: true,
    },
    {
        rootScopeEvent: RootScopeEvents.MARKETPLACE.EXTENSION_CLOSED,
        segmentName: 'Extension Closed',
        skipSegmentTrackData: true,
    },
    {
        rootScopeEvent: RootScopeEvents.AUTHENTICATION.SIGN_IN_FORM_SUBMITTED,
        segmentName: 'Signin Form Submitted',
        skipSegmentTrackData: true,
    },
    {
        rootScopeEvent: RootScopeEvents.AUTHENTICATION.SIGN_UP_FORM_SUBMITTED,
        segmentName: 'Signup Form Submitted',
        skipSegmentTrackData: true,
    },
    {
        rootScopeEvent: RootScopeEvents.PAYMENT.FINISHED,
        segmentName: 'Payment Finished',
        skipSegmentTrackData: true,
    },
    {
        rootScopeEvent: RootScopeEvents.FILE_TRANSFER.FINISHED,
        segmentName: 'File Transfer Finished',
        skipSegmentTrackData: true,
    },
];
export default config;
